// JsFromRoutes CacheKey 36bd82a1ea755b8a997ec126998fcd7b
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/client"

export default {
  show: /* #__PURE__ */ definePathHelper("get", "/api/:venue_slug/venue"),
  update: /* #__PURE__ */ definePathHelper("patch", "/api/:venue_slug/venue"),
}
